import React, { useState } from 'react';

const styles = {
    switch: {
        position: 'relative',
        display: 'inline-block',
        width: '40px',
        height: '24px',
        borderRadius: '10px',

    },
    slider: {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#ccc',
        transition: '.4s',
        borderRadius: '16px'
    },
    circle: {
        position: 'absolute',
        height: '20px',
        width: '20px',
        marginTop: '2px',
        backgroundColor: 'white',
        transition: '.4s',
        borderRadius: '50%',
    }
};

function Switch(props) {
    const [isChecked, setIsChecked] = useState(props.checked || false);

    const toggleCheck = () => {
        props.onChange && props.onChange(!isChecked);
        setIsChecked(!isChecked);
        
    }

    return (
        <label style={styles.switch}>
            <input type="checkbox" checked={isChecked} onChange={toggleCheck} 
                style={{display: 'none'}} />
            <div style={isChecked ? {...styles.slider, backgroundColor: '#2196F3'} : styles.slider}>
                <span style={isChecked ? {...styles.circle, transform: 'translateX(18px)'} : styles.circle}>
                </span>
            </div>
        </label>
    );
}

export default Switch;